import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  job: {},
  userObject: {},
  applicantEnrollment: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/job/vuex/index.js